import { extend } from 'vee-validate'
import { email } from 'vee-validate/dist/rules'

// Length rule
extend('email', {
  ...email,
  message: 'Proszę podać poprawny adres e-mail'
})
